export const GEN_AI_TILESET_COMBO_ID = 'genAITilesetCombo';
